import { Component } from '@angular/core';

@Component({
  selector: 'app-daily-sales-order',
  standalone: false,
  
  templateUrl: './daily-sales-order.component.html',
  styles: ``
})
export class DailySalesOrderComponent {

}
